
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5FLbD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6b0912ba6fe7215a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $6b0912ba6fe7215a$export$2e2bcd8739ae039 = {
    'fabric.editor.chromeCollapsedPlaceholder': "\uB0B4\uC6A9 \uC785\uB825...",
    'fabric.editor.editorAssistiveLabel': "\uC8FC \uCF58\uD150\uCE20 \uC601\uC5ED\uC785\uB2C8\uB2E4. \uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694.",
    'fabric.editor.headingLink.toolbarHelpTitle': "\uB3C4\uC6C0\uB9D0 \uB300\uD654 \uC0C1\uC790 \uC5F4\uAE30"
};

});


//# sourceMappingURL=ko.54da110d.js.map
